<template>
  <div id="dev-warning">
    <p class="m-0 text-white">
      <small>
        <strong>Esta é uma versão de desenvolvimento, todos os dados aqui contidos são para fins de teste</strong>
        <span class="dev-warning-sep"> · </span>
        <router-link :to="{ name: 'designSystem' }" class="dev-warning-link">Design system</router-link>
      </small>
    </p>
  </div>
</template>

<script>
export default {
  name: 'dev-warning'
}
</script>

<style scoped>
.dev-warning-link {
  color: inherit;
  text-decoration: underline;
}
</style>